import useCart from 'hooks/use-cart';
import useUI from 'hooks/use-ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { usePriceCartCalcs } from 'hooks/use-price-cart-calcs';
import { UseCartPricingReturns } from 'hooks/use-cart-pricing/use-cart-pricing.types';
import { useCartItemPricing } from './use-cart-item-pricing';

export function useCartPricing(): UseCartPricingReturns {
  const { isCalculating } = useCart();
  const { isCheckoutPage } = useUI();
  const flags = useFlags();

  const consolidateReceiptDiscountsEnabled = flags['core.cats-ecomm.consolidate-receipt-discounts.rollout'] ?? false;

  const priceCartEnabled = usePriceCartCalcs();
  const priceCartPricing = !isCalculating && priceCartEnabled;

  return {
    ...useCartItemPricing({ priceCartPricing, isCheckoutPage, consolidateReceiptDiscountsEnabled }),
  };
}
